<template>
  <div id="app">
    <component v-cloak :is="layout"></component>
    <vue-progress-bar></vue-progress-bar>
  </div>
</template>

<script>
const defaultLayout = "default";

/**
 * Export app.
 *
 * @type  {Object}
 */
export default {
  name: "App",

  /**
   * Computed proterties.
   *
   * @type  {Object}
   */
  computed: {
    layout() {
      return (this.$route.meta.layout || defaultLayout) + "-layout";
    }
  },

  /**
   * Called on mounted.
   */
  mounted() {
    // [App.vue specific] When App.vue is finish loading finish the progress bar
    this.$Progress.finish();
  },

  /**
   * Called on created.
   */
  created() {
    // [App.vue specific] When App.vue is first loaded start the progress bar
    this.$Progress.start();

    // Hook the progress bar to start before we move router-view
    this.$router.beforeEach((to, from, next) => {
      // Does the page we want to go to have a meta.progress object
      if (to.meta.progress !== undefined) {
        let meta = to.meta.progress;
        // parse meta tags
        this.$Progress.parseMeta(meta);
      }

      // Start the progress bar
      this.$Progress.start();

      // Continue to next page
      next();
    });

    // Hook the progress bar to finish after we've finished moving router-view
    this.$router.afterEach(() => {
      //  Finish the progress bar
      this.$Progress.finish();
    });
  }
};
</script>

<style lang="scss">
[v-cloak] {
  display: none;
}
</style>
